namespace $.$$ {

	export class $bog_music_account extends $.$bog_music_account {

		account() {
			return $bog_music_account_baza.home()
		}

		nickname(next?: string) {
			return this.account().nickname(next)
		}

		@$mol_mem
		lord_text() {
			const auth = this.$.$giper_baza_auth.current()
			if (!auth) return '—'
			return auth.pass().lord().str
		}

		account_key() {
			return String(this.$.$mol_state_local.value('$giper_baza_auth') ?? '')
		}

		account_link() {
			const key = this.account_key()
			if (!key) return ''
			return location.origin + location.pathname + location.search + '#account=' + encodeURIComponent(key)
		}

		Qr() {
			return this.qr_showed() ? super.Qr() : null as any
		}

		@$mol_mem
		qr_found(next?: string) {
			if (next) {
				this.import_link(next)
				this.apply_import()
			}
			return next ?? ''
		}

		@$mol_mem
		copy_status(next?: string) {
			return next ?? ''
		}

		@$mol_action
		copy() {
			const link = this.account_link()
			if (!link) {
				this.copy_status('Ключ не найден')
				return
			}
			try {
				navigator.clipboard.writeText(link)
				this.copy_status('Скопировано. Не делись публично!')
			} catch (e: any) {
				console.warn('[account] clipboard failed:', e?.message)
				this.copy_status('Не удалось — скопируй из адресной строки: ' + link)
			}
		}

		@$mol_mem
		import_link(next?: string) {
			return next ?? ''
		}

		@$mol_mem
		import_status(next?: string) {
			return next ?? ''
		}

		@$mol_action
		apply_import() {
			const raw = this.import_link().trim()
			if (!raw) {
				this.import_status('Вставь ссылку с #account=…')
				return
			}
			const match = raw.match(/[#&]account=([^&\s]+)/)
			const key = match ? decodeURIComponent(match[1]) : raw
			if (key.length < 172) {
				this.import_status('Ключ слишком короткий')
				return
			}
			const current = this.$.$mol_state_local.value('$giper_baza_auth')
			if (current !== key) this.$.$mol_state_local.value('$giper_baza_auth', key)
			this.import_status(current === key ? 'Перезапуск…' : 'Применено, перезагрузка…')
			location.reload()
		}

		@$mol_action
		reset_account() {
			if (typeof window === 'undefined') return
			try { window.localStorage.clear() } catch {}
			try { indexedDB.deleteDatabase('$giper_baza_mine') } catch {}
			const drop = $bog_music_disk.supported()
				? navigator.storage.getDirectory().then(root => root.removeEntry($bog_music_disk.folder, { recursive: true }))
				: Promise.resolve()
			drop.catch(() => {}).finally(() => location.reload())
		}

	}
}
